import React from "react"
import styled from "styled-components"
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core"

const StyledRadioFilter = styled.div`
  margin: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const DEFAULT_OPTIONS = ["Yes", "No", "Other"]

const RadioFilter = ({ value, onChange, options = DEFAULT_OPTIONS }) => {
  return (
    <StyledRadioFilter>
      <FormControl component="fieldset">
        <RadioGroup value={value} onChange={onChange}>
          {options.map(option => (
            <FormControlLabel
              key={option}
              value={option}
              control={<Radio />}
              label={option}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </StyledRadioFilter>
  )
}

export default RadioFilter
